import SortableTable from '../../../components/common/SortableTable';
import { Column, PaginationProps } from '../../../types/settings/settings';
import { ModulesDetail } from '../../../types/settings/ModuleTypes';
import { toastMessage } from '@/utils/toast-message';
import { deleteModule } from '@/actions/data-fetch-modules';

interface ModulesTableProps {
    initialData: ModulesDetail[];
    onEdit?: (user: ModulesDetail) => void;
    pagination?: PaginationProps;
    onPageChange?: (page: number) => void;
    onSearch?: (term: string) => Promise<void>;
    onSort?: (column: string, order: 'ASC' | 'DESC') => Promise<void>;
    isLoading?: boolean;
    searchTerm?: string;
    sortColumn?: string;
    sortOrder?: 'ASC' | 'DESC';
}

type ModulesDetailWithIndex = ModulesDetail & {
    [key: string]: unknown;
}

const ModuleTable = ({
    initialData,
    onEdit,
    pagination,
    onPageChange,
    onSearch,
    onSort,
    searchTerm = '',
    sortColumn,
    sortOrder,
}: ModulesTableProps) => {

    const handleDelete = async (module: ModulesDetail) => {
        try {
            await deleteModule(module.uuid);
            if (onPageChange) {
                onPageChange(pagination?.currentPage || 1);
            }
            toastMessage('Module deleted successfully', 'success');
        }
        catch (error) {

            toastMessage("Cannot delete module with associated columns", "error");
        }
    };

    const handleSearch = async (term: string) => {
        if (onSearch) {
            await onSearch(term);
        }
    };

    const handleSort = (key: string | number) => {
        if (onSort) {
            const newOrder = key === sortColumn && sortOrder === 'ASC' ? 'DESC' : 'ASC';
            onSort(key as string, newOrder);
        }
    };

    const Columns: Column<ModulesDetail>[] = [
        {
            key: 'module_name',
            col_name: 'module_name',
            label: 'Module',
            sortable: true,
            searchable: true,
        }
    ]

    const currentPage = pagination?.currentPage || 1;
    const totalCount = pagination?.totalItems || 0;
    const itemsPerPage = pagination?.itemsPerPage || 10;

    const tableSortConfig = {
        key: sortColumn as keyof ModulesDetail || null,
        direction: sortOrder?.toLowerCase() as 'asc' | 'desc' | null || null
    };

    return (
        <>
            <SortableTable<ModulesDetailWithIndex>
                columns={Columns as unknown as Column<ModulesDetailWithIndex>[]}
                data={initialData as unknown as ModulesDetailWithIndex[]}
                onDelete={(row) => handleDelete(row as unknown as ModulesDetail)}
                onEdit={onEdit ? (row) => onEdit(row as unknown as ModulesDetail) : undefined}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                totalCount={totalCount}
                onPageChange={onPageChange || (() => { })}
                onSearch={handleSearch}
                searchTerm={searchTerm}
                sortConfig={tableSortConfig as {
                    key: keyof ModulesDetailWithIndex | null;
                    direction: 'asc' | 'desc' | null;
                }}
                onSort={handleSort}
            />

        </>
    );
};

export default ModuleTable;
